﻿/// <reference path="../../../typings/plupload.d.ts" />

namespace eXpress.core {
	export type UploadSettings = {
		afterInit: () => void;
		beforeUploadStart: (totalFiles: number) => void;
		fileUploaded: (uploadedFiles: number) => void;
		importFinished: (folderId: string, importedFileIds: string[] | null, nrOfFailedUploads: number, failedFileNames: string[] | null) => void;
		uploadButtonId: string;
		createUploadSessionAsync?: (runtime: string) => Promise<services.ICreateUploadSessionResult>
	};
	export class Upload {

		private remainingFiles = 0;
		private folderId: string;
		private uploadErrorTimer: number | undefined;
		private uploadErrors = 0;
		private pollSessionCounter = 0;
		private uploading: boolean;
		private failedFileNames: string[] = [];

		private flow: string;
		private sessionId: string;

		private uploadService: eXpress.services.UploadService;
		private context: IAppContext;

		private settings: UploadSettings;

		private plUploader: plupload.Uploader;

		public constructor(settings: UploadSettings, context: eXpress.core.IAppContext, uploadService: eXpress.services.UploadService, flow: string) {
			this.flow = flow;
			this.uploadService = uploadService;
			this.context = context;
			this.settings = settings;
		}

		public setFolderId(folderId: string) {
			this.folderId = folderId;
		}

		public init() {
			this.plUploader = new plupload.Uploader({
				runtimes: 'html5, silverlight, html4',
				browse_button: this.settings.uploadButtonId,
				url: "http://trunk.localhost",
				flash_swf_url: '/plupload/Moxie.swf',
				silverlight_xap_url: '/plupload/Moxie.xap',
				filters: {
					max_file_size: '100mb',
					mime_types: [
						{ title: "Jpeg files", extensions: "jpe,jpeg,jpg" },
						{ title: "Png files", extensions: "png" },
						{ title: "HEIF files", extensions: "heic,heif" }
					]
				},
				init: {
					Init: (uploader) => {
						//if (SupportsTouchEvents() && isChrome) {
						//	setTimeout(function () { $('input').attr('accept', 'image/*') }, 300);
						//}

						this.remainingFiles = 0;
						this.uploading = false;

						this.settings.afterInit && this.settings.afterInit();
					},
					FilesAdded: (uploader, files) => {
						if (this.folderId && this.folderId !== core.emptyGuid) {
							this.createUploadSessionForFolderAsync()
								.then((uploadSession) => this.createUploadSessionComplete(files, uploader, uploadSession));
						} else if (this.settings.createUploadSessionAsync) {
							this.settings.createUploadSessionAsync(uploader.runtime)
								.then((uploadSession) => this.createUploadSessionComplete(files, uploader, uploadSession));
						}
					},
					UploadComplete: (uploader, files) => {
						this.uploading = false;
						this.startSessionPolling(files.length);
						uploader.splice();
					},
					FileUploaded: (uploader, file, response) => {
						this.remainingFiles--;
						this.settings.fileUploaded(uploader.files.length - this.remainingFiles);
					},
					QueueChanged: (uploader) => {
						this.remainingFiles = uploader.files.length;
						window.clearTimeout(this.uploadErrorTimer);
					},
					Error: (uploader, error) => {
						if (error.code !== -200) {
							this.failedFileNames.push(error.file.name);

							this.uploadErrors++;

							// HandleMultiUploadErrors is only called if at least 1 file was succesfully uploaded
							// if all files are rejected we still need HandleMultiUploadErrors to be called
							// once we added a file to the queue, we can kill this timer
							if (uploader.files.length === 0) {
								if (this.uploadErrorTimer !== null) {
									// wait for all errors
									window.clearTimeout(this.uploadErrorTimer);
								}
								this.uploadErrorTimer = window.setTimeout(() => {
									this.settings.importFinished(this.folderId, null, this.uploadErrors, this.failedFileNames);
									this.resetUploadErrors();
								}, 1000);
							}
						}
					}
				}
			});

			this.plUploader.init();
		}

		public isUploading(): boolean {
			return this.uploading;
		}

		public browse() {
			$("#" + this.settings.uploadButtonId).trigger("click");
		}

		public destroy() {
			if (this.plUploader)
				this.plUploader.destroy();
		}

		public refresh() {
			if (this.plUploader)
				this.plUploader.refresh();
		}

		private startSessionPolling(expectedFiles: number) {
			this.pollSessionCounter = 0;
			window.setTimeout(() => this.pollSession(expectedFiles), 1000);
		}

		private pollSession(expectedFiles: number) {
			this.pollSessionCounter++;
			this.uploadService.setToken().then(_ => {
				this.uploadService.checkImportStatusForSessionAsync(GetCookie("accid"), this.sessionId)
					.then(imports => {
						const finishedImports = imports.filter(importItem => importItem.status !== services.ImportStatus.Waiting);
						if (finishedImports.length === expectedFiles) {
							const importedFiles = imports.filter(importItem => importItem.status === services.ImportStatus.Imported);
							const failedFiles = imports.filter(i => i.status === services.ImportStatus.Failed);
							this.failedFileNames.push(...failedFiles.map(m => m.originalFileName));
							this.uploadErrors += failedFiles.length;
							this.settings.importFinished(this.folderId, importedFiles.map(importedFile => importedFile.fileId), this.uploadErrors, this.failedFileNames);
							this.resetUploadErrors();
						}
						else {
							window.setTimeout(() => this.pollSession(expectedFiles), 1000 + this.pollSessionCounter * 1000);
						}
					});
			});
		}

		private createUploadSessionForFolderAsync(): Promise<services.ICreateUploadSessionResult> {
			return this.uploadService.setToken().then(_ => {
				return this.uploadService.createUploadSessionAsync(this.context.pointOfSaleId, GetCookie("accid"), this.folderId, this.flow, this.plUploader.runtime);
			});
		}

		private createUploadSessionComplete(files: any, uploader: plupload.Uploader, uploadSession: services.ICreateUploadSessionResult) {
			this.uploading = true;
			this.settings.beforeUploadStart(files.length);
			this.sessionId = uploadSession.id;
			uploader.settings.url = uploadSession.uploadUrl + '?uploadId=' + uploadSession.id;
			uploader.start();
		}

		public resetUploadErrors() {
			this.uploadErrors = 0;
			this.uploadErrorTimer = undefined;
			this.failedFileNames = [];
		}

		public getUploadErrorPopupAsync(contentManager: core.ContentManager, numberOfErrors: number, failedFileNames: string[]): JQueryPromise<JQuery> {
			const stringToHash = failedFileNames.join("");
			const hashCode = this.convertToHash(stringToHash);

			return ContentPopup.createDialogAsync(
				contentManager,
				{
					labelContentKey: "Label.plupload.error.multi",
					dialogId: "importFailed-" + hashCode,
					okContentKey: "Label.CloseButtonText",
					cssClass: "notification",
					replacements: [numberOfErrors.toString(), failedFileNames.join(", ")]
				}
			);
		}

		public convertToHash(str): string {
			let results = "";
			const fixedNumber = 100;
			for (let i = 0; i < str.length; i++) {
				results += (fixedNumber + str[i].charCodeAt(0)).toString();
			}

			return results.replace('.', '').replace('+', '').toString();
		}
	}
}
